module.exports = __webpack_public_path__ + "static/media/tire.4e7371de.svg";